import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from "react-toastify";
import LoadingAction from '../../../components/Loader';
import { useEditProductMutation } from '../../../Services/ProductApi';
import CategoryDropdown from './categoryDropdown';
import { GetUrl } from "../../../config/GetUrl"
const buttonWidth = {
    width: '100%'
};

const EditProduct = (props) => {
    const {  editData,  showViewModal, handleClose, categories } = props;
    const [showLoader, setShowLoader] = useState(false);
    const [editProduct] = useEditProductMutation();
    const [prevCategoryIds, setPrevCategoryIds] = useState([]);
    const [deletedCategoryIds, setDeletedCategoryIds] = useState([]);
    const [newCategoryIds, setNewCategoryIds] = useState([]);
  useEffect(()=>{
  console.log({newCategoryIds,deletedCategoryIds})
  },[newCategoryIds,deletedCategoryIds])
    const [formFields, setFormFields] = useState({
        name: '',
        description: '',
        recommended: false,
        hotSelling: false,
    });

    const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
    const [image, setImage] = useState([]);
    const [videos, setVideos] = useState([]);
    const [variants, setVariants] = useState([]);

  


    const handleImageChange = (event) => {
        const files = Array.from(event.target.files);
        const newImages = files.map(file => ({
            id: URL.createObjectURL(file),
            file,
            url: URL.createObjectURL(file),
        }));
        setImage(prev => [...prev, ...newImages]);
        event.target.value = '';
    };

    const handleVideoChange = (event) => {
        const files = Array.from(event.target.files);
        const newVideos = files.map(file => ({
            id: URL.createObjectURL(file),
            file,
            url: URL.createObjectURL(file),
        }));
        setVideos(prev => [...prev, ...newVideos]);
        event.target.value = '';
    };

    const handleDeleteImage = (id) => {
        setImage(prev => prev.filter(image => image.id !== id));
    };

    const handleDeleteVideo = (id) => {
        console.log({ id })
        setVideos(prev => prev.filter(video => video.id !== id));
    };

    const addVariantRow = () => {
        setVariants(prev => [...prev, { quantity: '', price: '', stock: '' }]);
    };

    const removeVariantRow = (index) => {
        setVariants(prev => prev.filter((_, i) => i !== index));
    };

    // const handleVariantChange = (index, field, value) => {
    //     const updated = [...variants];
    //     updated[index][field] = value;
    //     setVariants(updated);
    // };
    const handleVariantChange = (index, field, value) => {
    const updated = variants.map((variant, i) =>
        i === index ? { ...variant, [field]: value } : variant
    );
    setVariants(updated);
};


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formFields.name || selectedCategoryIds.length === 0) {
            toast.error("Product name and category are required.");
            return;
        }

        const formData = new FormData();
        formData.append('name', formFields.name);
        formData.append('description', formFields.description);
        formData.append('isRecommended', formFields.recommended);
        formData.append('isHotSelling', formFields.hotSelling);

        selectedCategoryIds.forEach((id, idx) => {
            if (!deletedCategoryIds.includes(id)) {
                formData.append(`categories[${idx}]`, id);
            }
        });
        deletedCategoryIds.forEach((id, idx) => {
                formData.append(`deletedCategoryIds[${idx}]`, id);
           
        });
        newCategoryIds.forEach((id, idx) => {
                formData.append(`newCategoryIds[${idx}]`, id);
        
        });
        if (image.length === 0) {
            toast.error("Atleast one image is required.");
            return;
        }
        console.log({ image })
        image.forEach((img, idx) => {
            if (img.file) {
                formData.append('image', img.file);
            } else {
                formData.append(`images[${idx}]`, img.id); // or 'images' if backend handles both
            }
        });
        videos.forEach((video, idx) => {
            if (video.file) {
                formData.append('video', video.file);
            } else {
                formData.append(`videos[${idx}]`, video.id); // or 'images' if backend handles both
            }
        });

        formData.append('variants', JSON.stringify(variants));

        setShowLoader(true);
        console.log({ idddd: editData.productId })
        try {
            const res = await editProduct({ productId: editData.productId, formData }).unwrap();
            toast.success("Product Updated Success !!");
       
            handleClose();

        } catch (err) {
            toast.error(err?.data?.message || 'Something went wrong');
        } finally {
            setShowLoader(false);
        }
    };

    useEffect(() => {
        if (editData && showViewModal) {
            setFormFields({
                name: editData.name || '',
                description: editData.description || '',
                recommended: editData.isRecommended || false,
                hotSelling: editData.isHotSelling || false,
            });
            setSelectedCategoryIds([editData.categories?.map(category => category._id)].filter(Boolean).flat());
            setPrevCategoryIds([editData.categories?.map(category => category._id)].filter(Boolean).flat())
            setImage(
                (editData.images || []).map((img, i) => ({
                    id: img,
                    file: null,
                    url:img,
                }))
            );
            setVideos(
                (editData.videos || []).map((vid, i) => ({
                    id: vid,
                    file: null,
                    url: vid,
                }))
            );
            setVariants(editData.variants || []);
        }
    }, [editData, showViewModal]);

    return (
        <Modal show={showViewModal} onHide={handleClose} centered size="lg" scrollable>
            <Modal.Header closeButton className="border-0 mt-4 pt-0 pb-2">
                <div className="d-flex justify-content-center w-100">
                    <Modal.Title className='h4'>View Product</Modal.Title>
                </div>
            </Modal.Header>

            {showLoader && <LoadingAction />}

            <Modal.Body className='px-md-4'>
                <form onSubmit={handleSubmit} className="form-login n">
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Product Name</label>
                            <input
                                type="text"
                                name="name"
                                value={formFields.name}
                                className="form-control"
                                placeholder="Enter Name"
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Categories</label>
                            <CategoryDropdown
                                categories={categories?.filter(Boolean)}
                                selectedCategoryIds={selectedCategoryIds}
                                prevState={prevCategoryIds}
                                setDeletedCategoryIds={setDeletedCategoryIds}
                                setNewCategoryIds={setNewCategoryIds}
                            />
                        </div>



                        <div className="col-md-12 mb-3">
                            <label className="form-label">Description</label>
                            <textarea
                                name="description"
                                rows={2}
                                className="form-control"
                                placeholder="Enter Description"
                                value={formFields.description}
                            ></textarea>
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Product Images</label>
                            <input
                                type="file"
                                className="form-control"
                                multiple
                                accept="image/*"
                            />
                            <div className="preview-container d-flex mt-2 flex-wrap gap-2">
                                {image.map(image => (
                                    <div className="position-relative" key={image.id}>
                                        <img src={image.url} alt="Preview" height={80} />
                                      
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Product Videos</label>
                            <input
                                type="file"
                                className="form-control"
                                multiple
                                accept="video/*"
                             
                            />
                            <div className="preview-container d-flex mt-2 flex-wrap gap-2">
                                {videos.map(video => (
                                    <div className="position-relative" key={video.id}>
                                        <video src={video.url} height={80} controls />
                                   
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-md-12 d-flex gap-4 mb-3">
                            <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" id="recommended" name="recommended" checked={formFields.recommended}  />
                                <label className="form-check-label" htmlFor="recommended">Recommended</label>
                            </div>
                            <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" id="hotSelling" name="hotSelling" checked={formFields.hotSelling} />
                                <label className="form-check-label" htmlFor="hotSelling">Hot Selling</label>
                            </div>
                        </div>

                        <div className="col-md-12 mb-3">
                            <label className="form-label">Quantity Variants</label>
                            <div className="table-responsive mobile-form-input-width">
                                <table className="table table-bordered text-nowrap">
                                <thead>
                                    <tr>
                                        <th>Weight</th>
                                        <th>Price</th>
                                        <th>MOQ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {variants.map((variant, index) => (
                                        <tr key={index}>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={variant.weight}
                                                    
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={variant.price}
                                                   
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={variant.minOrderQty}
                                                   
                                                />
                                            </td>
                                           
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            </div>
                        </div>

                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default EditProduct;
